<template>
  <m-base>
    <!--<m-section-banner/>-->
    <!--<m-section-prospects/>-->
    <!--<m-section-service />-->
    <!--<m-section-analyze />-->
    <m-v4 v-show="uiVerstion===1"/>
    <m-v2 v-show="uiVerstion===2"/>
    <div class="go-top"  v-scroll-to="'#landing-top'" v-show="showGoTop">
      <icon name="chevron-up" />
    </div>
  </m-base>
</template>

<script>
  import MBase from '@/components/layouts/MBase'
  import MSectionBanner from '@/components/landings/MSectionBanner'
  import MSectionProspects from '@/components/landings/MSectionProspects'
  import MSectionService from '@/components/landings/MSectionService'
  import MSectionAnalyze from '@/components/landings/MSectionAnalyze'
  import MV2 from '@/components/landings/MV2'
  import MV4 from '@/components/landings/MV4'

  export default {
    components: {
      MV2,
      MV4,
      MBase,
      MSectionBanner,
      MSectionProspects,
      MSectionService,
      MSectionAnalyze
    },
    data () {
      return {
        msg: 'Welcome to Your Vue.js App',
        showGoTop: false
      }
    },
    computed: {
      uiVerstion () {
        return this.$store.getters['user/isNewUI']
      }
    },
    created () {
      this.toggleGoTop()
    },
    methods: {
      toggleGoTop () {
        var that = this
        window.onscroll = function () {
          let top = document.documentElement.scrollTop || document.body.scrollTop
          if (top > 300) {
            that.showGoTop = true
          } else {
            that.showGoTop = false
          }
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .go-top {
    position: fixed;
    right: 64px;
    top: 60%;
    width: 64px;
    height: 64px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    box-shadow: 0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12)!important;
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// src/pages/Landing.vue